/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_Q5Inputs */

const en_pc_online_faq_q5 = /** @type {(inputs: Pc_Online_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I print from PdfCraft Online?`)
};

const zh_pc_online_faq_q5 = /** @type {(inputs: Pc_Online_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以在 PdfCraft 在线版中打印吗？`)
};

/**
* | output |
* | --- |
* | "Can I print from PdfCraft Online?" |
*
* @param {Pc_Online_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_q5 = /** @type {((inputs?: Pc_Online_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_q5(inputs)
	return zh_pc_online_faq_q5(inputs)
});
export { pc_online_faq_q5 as "pc.online.faq.q5" }